<div class="d-flex flex-column">
  <div>
    <ey-display-rating
      [maxRating]="maxRating"
      [ratingType]="ratingType"
      [isDisabled]="isDisabled"
      (onRatingChange)="onRating($event)"
      [ctrl_id]="ctrl_id"
      [ratingValue]="ratingValue"
      [decreaseRatingSize]="decreaseRatingSize"
    >
    </ey-display-rating>
  </div>
  <div
    *ngIf="!disableErrorEvaluation && showError && !noErrorLabel"
    class="rating__errmsg"
    [class.change-error-display-position]="changeErrorDisplayPositionForLongMessages"
  >
    <i class="err_icon icon-ico_error_toast"></i>{{ meta.errorMsg }}
  </div>
</div>
